<template>
  <div class="content-block dx-card responsive-paddings">
    <DxDataGrid :ref="gridRefName" :data-source="dataSource" :columnAutoWidth="true" :show-borders="true"
      :show-column-lines="true" :focused-row-enabled="true" @exporting="onExporting">

      <DxSearchPanel :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="infinite" />
      <DxSorting mode="multiple" />
      <DxExport :enabled="true" />
      <DxEditing :allow-updating="true" :allow-adding="false" :allow-deleting="true" mode="popup" />

      <DxColumn type="buttons">
        <DxButton name="edit" />
      </DxColumn>

      <DxColumn data-field="spaceId" caption="스페이스 ID" :header-filter="{ allowSearch: true }">
        <DxRequiredRule />
        <DxPatternRule pattern="[A-Za-z0-9]{1,20}$" ^[A-Za-z0-9-_]{1,10}$ message="20자 까지 등록 가능(영문 대/소문자 숫자로 구성, 공백불가)" />
      </DxColumn>

      <DxColumn data-field="spaceName" caption="스페이스 이름" :header-filter="{ allowSearch: true }">
        <DxRequiredRule />
        <DxPatternRule pattern="^.{1,30}$" message="30자 까지 등록 가능" />
      </DxColumn>

      <DxMasterDetail :enabled="true" template="master-detail" />
      <template #master-detail="{ data }">
        <History :master-detail-data="data" :url="`/api/ASPC/selectHistory`" :keyName="operation"
          :columns="historyColumns" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxSorting,
  DxExport,
  DxHeaderFilter,
  DxEditing,
  DxSearchPanel,
  DxRequiredRule,
  DxPatternRule,
  DxMasterDetail
} from "devextreme-vue/data-grid";
import History from "../_common/SIMPLE_HISTORY";
import { userAuth } from "../../utils/syscodedata";
import dsu from "../../utils/dataSourceUtils";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSorting,
    DxExport,
    DxHeaderFilter,
    DxEditing,
    DxSearchPanel,
    DxRequiredRule,
    DxPatternRule,
    DxMasterDetail,
    History
  },
  data() {
    return {
      gridRefName: 'grid',
      dataSource: dsu.getComDSGrid('/api/ASPC', 'spaceId', '', '스페이스 ID'),
      userAuth: userAuth,
      historyColumns: [{ dataField: "transTime", caption: "변경 시간" },
      { dataField: "spaceName", caption: "스페이스 이름" },
      { dataField: "userId", caption: "변경 사용자" },
      { dataField: "dml", caption: "Action" }]
    };
  },
  methods: {
    onExporting(e) {
      e.fileName = this.$route.meta.transName;
    }
  }
};

</script>

<style scoped></style>